//@flow
import React from 'react';
import {colors, makeStyles} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import VendorLogo from '../../../elements/VendorLogo/VendorLogo';
import shrunkLogo from '../../../assets/img/shrunk-logo.svg';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import {useSidebarContext} from './SidebarContainer';

const useStyles = makeStyles(theme => ({
  toolbar: {
    ...theme.mixins.toolbar,
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '16px 0 16px 28px',
    alignItems: 'center',
    '& img': {
      maxHeight: 56,
    },
    '&[data-shrink="true"]': {
      justifyContent: 'center',
      padding: '.5rem ',
    },
  },
  expandIcon: {
    position: 'absolute',
    right: -16,
    top: 24,
    borderRadius: '50%',
    width: '2rem',
    height: '2rem',
    backgroundColor: colors.purple,
    color: '#fff',
  },
}));

export default function SidebarHeader() {
  const classes = useStyles();

  const {toggleShrink, shrink} = useSidebarContext();

  return (
    <div className={classes.toolbar} data-shrink={shrink}>
      {shrink ? <img src={shrunkLogo} alt="" /> : <VendorLogo />}
      <CustomButton
        variant="contained"
        className={classes.expandIcon}
        onClick={toggleShrink}
      >
        {!shrink ? <ChevronLeftIcon /> : <ChevronRightIcon />}
      </CustomButton>
    </div>
  );
}
